import jsPDF from 'jspdf';

export const exportProductsToPDF = async (products, searchTerm = '', selectedCategory = '', categories = [], token) => {
  let allProducts = Array.isArray(products) ? products : [];
  console.log('Products passed to PDF:', allProducts.length);

  const doc = new jsPDF('portrait', 'mm', 'a4');
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  
  // Load logo
  const loadLogo = () => {
    return new Promise((resolve) => {
      const logoImg = new Image();
      logoImg.crossOrigin = 'anonymous';
      logoImg.onload = () => resolve(logoImg);
      logoImg.onerror = () => resolve(null);
      logoImg.src = 'http://localhost:8000/media/images/logo.jpg';
    });
  };
  
  const logoImg = await loadLogo();
  
  // Modern gradient header
  doc.setFillColor(26, 35, 126); // Deep blue
  doc.rect(0, 0, pageWidth, 45, 'F');
  
  // Accent stripe
  doc.setFillColor(255, 193, 7); // Gold accent
  doc.rect(0, 40, pageWidth, 5, 'F');
  
  // Logo with modern styling
  if (logoImg) {
    doc.setFillColor(255, 255, 255);
    doc.roundedRect(15, 10, 25, 25, 3, 3, 'F');
    doc.addImage(logoImg, 'JPEG', 17, 12, 21, 21);
  }
  
  // Company branding
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(20);
  doc.setFont('helvetica', 'bold');
  doc.text('Sedis Niazi Wholesale', 45, 20);
  
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.text('Email: info@brotheranqadari.com', 45, 28);
  doc.text('Phone: +93 70 285 0840', 45, 34);
  
  // Document title
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text('PRICE LIST', pageWidth - 15, 25, { align: 'right' });
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.text(new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }), pageWidth - 15, 32, { align: 'right' });
  
  // Info card
  doc.setFillColor(245, 247, 250);
  doc.roundedRect(15, 52, pageWidth - 30, 18, 2, 2, 'F');
  doc.setDrawColor(220, 225, 230);
  doc.roundedRect(15, 52, pageWidth - 30, 18, 2, 2, 'S');
  
  doc.setTextColor(33, 37, 41);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text('Total Products:', 20, 59);
  doc.setFont('helvetica', 'normal');
  doc.text(String(allProducts.length), 55, 59);
  
  doc.setFont('helvetica', 'bold');
  doc.text('Generated:', 20, 66);
  doc.setFont('helvetica', 'normal');
  doc.text(new Date().toLocaleString('en-US'), 55, 66);
  
  let yPos = 78;
  let globalIndex = 0;
  
  // Group products by category
  const productsByCategory = {};
  allProducts.forEach(product => {
    const categoryName = product.category_details?.name || 'Uncategorized';
    if (!productsByCategory[categoryName]) {
      productsByCategory[categoryName] = [];
    }
    productsByCategory[categoryName].push(product);
  });
  
  // Draw categories
  Object.keys(productsByCategory).forEach(categoryName => {
    const products = productsByCategory[categoryName];
    
    if (yPos > pageHeight - 40) {
      doc.addPage('portrait');
      yPos = 20;
    }
    
    // Category header with modern design
    doc.setFillColor(26, 35, 126);
    doc.roundedRect(15, yPos - 5, pageWidth - 30, 12, 2, 2, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.text(`${categoryName}`, 20, yPos + 2);
    doc.setFontSize(8);
    doc.text(`(${products.length} items)`, pageWidth - 20, yPos + 2, { align: 'right' });
    yPos += 14;
    
    // Modern table header
    doc.setFillColor(52, 58, 64);
    doc.rect(15, yPos - 4, pageWidth - 30, 10, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(8);
    doc.setFont('helvetica', 'bold');
    doc.text('#', 18, yPos + 2);
    doc.text('Product Name', 28, yPos + 2);
    doc.text('Pack', 80, yPos + 2);
    doc.text('Carton', 110, yPos + 2);
    doc.text('RAF', 140, yPos + 2);
    doc.text('Description', 160, yPos + 2);

    yPos += 12;
    
    // Products with alternating rows
    products.forEach((product, index) => {
      if (yPos > pageHeight - 20) {
        doc.addPage('portrait');
        yPos = 20;
      }
      
      globalIndex++;
      
      // Alternating row colors
      if (index % 2 === 0) {
        doc.setFillColor(248, 249, 250);
      } else {
        doc.setFillColor(255, 255, 255);
      }
      doc.rect(15, yPos - 4, pageWidth - 30, 9, 'F');
      
      // Row border
      doc.setDrawColor(233, 236, 239);
      doc.setLineWidth(0.1);
      doc.line(15, yPos + 5, pageWidth - 15, yPos + 5);
      
      doc.setTextColor(33, 37, 41);
      doc.setFontSize(8);
      doc.setFont('helvetica', 'normal');
      
      doc.text(String(globalIndex), 18, yPos + 1);
      doc.text(String(product.name || '-').substring(0, 20), 28, yPos + 1);
      doc.text(String(product.pack || '-'), 80, yPos + 1);
      doc.text(String(product.carton || '-'), 110, yPos + 1);
      doc.text(String(product.raf || '-').substring(0, 10), 140, yPos + 1);
      doc.text(String(product.description || '-').substring(0, 15), 160, yPos + 1);


      
      yPos += 9;
    });
    
    yPos += 8;
  });
  
  // Modern footer
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    
    // Footer line
    doc.setDrawColor(220, 225, 230);
    doc.setLineWidth(0.5);
    doc.line(15, pageHeight - 15, pageWidth - 15, pageHeight - 15);
    
    doc.setFontSize(7);
    doc.setTextColor(108, 117, 125);
    doc.setFont('helvetica', 'normal');
    doc.text('Powered by Afghan Cosmos IT Solutions | www.afghancosmos.com', pageWidth / 2, pageHeight - 8, { align: 'center' });
    
    doc.setFont('helvetica', 'bold');
    doc.text(`Page ${i} of ${totalPages}`, pageWidth - 20, pageHeight - 8, { align: 'right' });
  }
  
  const timestamp = new Date().toISOString().replace(/[:.]/g, '-').substring(0, 19);
  doc.save(`Price_List_${timestamp}.pdf`);
};